import React, {useRef} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Shows the lookthrough date in a different colour depending on its age
 */
export default function FundTooltip(props) {
    const fundAuth = props.fundAuth;
    const otherIsins = fundAuth.otherIsins;

    const target = useRef(null);

    let elem;

    if (otherIsins && otherIsins.length > 0) {

        elem =
            <OverlayTrigger
                placement='auto'
                delay={{show: 500, hide: 0}}
                trigger={["hover", "focus"]}
                target={target}
                overlay={
                    <Tooltip id="tooltip-bottom">
                        {otherIsins.map((item, i) => {
                            return <div className={'setup-row'}>
                                <div className={"setup-col"} style={{flexBasis: '120px', padding: '1rem'}}>
                                    {item}
                                </div>
                            </div>
                        })}
                    </Tooltip>
                }
                defaultShow={false}>
                {/*need to set display to prevent conflict between tr mouseover and tooltip*/}
                <span ref={target} style={{display: 'inline-block'}}>
                    {fundAuth.fundIsin}*
                </span>
            </OverlayTrigger>;
    } else {
        elem = fundAuth.fundIsin;
    }

    return elem;
}
